import styled, { css } from 'styled-components'

/* style */
const GlobalCheckboxStyles = css`
  grid-gap: 6px;
  position: relative;
  cursor: pointer;
  user-select: none;
  align-items: center;
  padding-left: 24px;
  font-weight: 100;
  @media (min-width: 425px) {
    padding-left: 24px;
  }
  input:checked ~ span, input.checked ~ span {
    background-color: var(--active-checkbox-background-color);
  }
  input:checked ~ span:after, input.checked ~ span:after {
    display: grid;
  }
`;
const BigDefaultCheckmarkStyled = css`
  width: 16px;
  height: 16px;

  &:after {
    left: 4px;
    top: 0;
    width: 4px;
    height: 8px;
  }
`
const getInputContainerStyled = css`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`
const getCheckmarkContainerStyled = css`
  position: absolute;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: var(--checkbox-background-color);
  border: 1px solid var(--checkbox-border-color);
  border-radius: 3px;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 3px;
    top: -1px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    border-radius: 4px;
  }
`
const arrowIconStyles = css`
  padding-right: 18px;

  i {
    position: absolute;
    right: 8px;
    top: 50%;
    margin-top: -10px;
  }
`
/* style */

/* function */
const getCheckboxModifiedStyled = ({flow, iconRight }) => {
  if(iconRight) return arrowIconStyles
  
  switch(flow){
    case 'column':
      return `display: inline-grid; grid-auto-flow: column;`
    default:
      return `display: grid; grid-auto-flow: row;`
  }
}
const getCheckmarkModifiedStyled = ({mode}) => {
  if(mode === 'bigdefault') return BigDefaultCheckmarkStyled
}
const getCheckmarkPropsModifiedStyled = props => {
  let modifiedStyled = ``
  if(props.isError) {
    modifiedStyled += ` border:1px solid #fc5c64; `
  }
  return modifiedStyled
}
/* function */

/* component */
export const CheckmarkContainer = styled.span`
  ${getCheckmarkContainerStyled}
  ${getCheckmarkModifiedStyled}
  ${getCheckmarkPropsModifiedStyled}
`
export const CheckboxNewContainer = styled.label`
  ${GlobalCheckboxStyles}
  ${getCheckboxModifiedStyled}
  & ${CheckmarkContainer} {
    top: 0;
  }
  > input {
    ${getInputContainerStyled}
  }
`
export const CheckboxContainer = styled.label`
  ${GlobalCheckboxStyles}
  ${getCheckboxModifiedStyled}
`;
export const InputContainer = styled.input`
  ${getInputContainerStyled}
`
/* component */